// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c975c4e","455":"44a57180"}[chunkId] + ".chunk.js";
};